/* 基本数据信息 */
const library = {
  toggle: false, // 头部切换主题
};
export default library;